module.exports = "/images/merchant-placeholder-img-background.png";